import { render, staticRenderFns } from "./AddTimestamp.vue?vue&type=template&id=60c313e8&"
import script from "./AddTimestamp.vue?vue&type=script&lang=js&"
export * from "./AddTimestamp.vue?vue&type=script&lang=js&"
import style0 from "./AddTimestamp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports